import { render } from "./customerTable.vue?vue&type=template&id=8414bb3e"
import script from "./customerTable.vue?vue&type=script&lang=js"
export * from "./customerTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__